const HighlightedText=({content})=>{
    return(
        <span className="bg-gradient-text bg-clip-text">{content}</span>
    )
}
export default HighlightedText